<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    isCollapse: {
      type: Boolean
    },
    hasOneShowingChild: {
      type: Boolean,
      default: true
    }
  },
  render(h, context) {
    const { icon, title, hasOneShowingChild, isCollapse } = context.props
    const vnodes = []

    if (icon) {
      // if (hasOneShowingChild && isCollapse) {
      //   vnodes.push(<span>{(title)}</span>)
      // } else {
        vnodes.push(<svg-icon icon-class={icon}/>)
      //}
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>
